import { render } from "./index.vue?vue&type=template&id=5d1b94a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5d1b94a4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5d1b94a4"

export default script